/* global angular, jQuery */
require('../../../node_modules/photoswipe/dist/photoswipe.css')
require('script-loader!photoswipe')
require('../components/loader/loader.css')
require('script-loader!../../../node_modules/photoswipe/dist/photoswipe-ui-default.js')
require('script-loader!../../../node_modules/jquery.scrollto/jquery.scrollTo.min.js')
require('script-loader!../../../node_modules/angular-socialshare/dist/angular-socialshare.min.js')
require('../../scss/pages/dettaglio.scss')

// app files
require('../../../src/config.js')
require('../components/breadcrumbs/breadcrumbs.js')
require('../components/loader/loader.js')
require('../components/related/related.js')
require('../components/hierarchytree/hierarchytree.js')

angular
  .module('app')
  .filter('sanitize', [
    '$sce',
    function ($sce) {
      return htmlCode => $sce.trustAsHtml(htmlCode)
    }
  ])
  .filter('filterCol', function () {
    return function (filtro) {
      return encodeURI(
        'types=' +
        filtro.name +
        '|' +
        filtro.id +
        '|' +
        filtro.path.replace(new RegExp('/', 'g'), '%2F')
      )
    }
  })
  .controller('DetailCtrl', function (
    $http,
    $timeout,
    $scope,
    $location,
    $q,
    $window,
    $document,
    ID,
    ATTS,
    ENDPOINT_SUMMARY,
    ENDPOINT_SEARCH,
    ENDPOINT_RELATED,
    LINKS
  ) {
    var vm = this
    vm._ = _
    // Elementi del controller
    vm.loaded = false
    vm.unavailable = false
    vm.id = ID
    vm.detail = {}
    vm.summary = {}
    vm.subtitle = ''
    vm.shareUrl = $location.absUrl()
    vm.LINKS = LINKS
    vm.openTree = false
    vm.isFixed = false
    vm.showbuy = false
    vm.showbuyURL = ''

    init()

    var winH = $window.innerHeight
    var bottomOffset = 59
    if (vm.searchURL) {
      bottomOffset = 130
    }

    var treeContainer = angular.element('#treeContainer')
    if (treeContainer && treeContainer[0]) {
      var treeContainerTop = treeContainer[0].getBoundingClientRect().top
      vm.heightCheck = function () {
        // var treeH = angular.element('#treeContainer').innerHeight()
        angular.element($window).bind('scroll', function (e) {
          var docH = $document.height()
          $timeout(function () {
            vm.isFixed = (treeContainerTop <= e.currentTarget.scrollY) && ((docH - (winH + bottomOffset)) > e.currentTarget.scrollY)
          }, 100)
        })
      }
    }

    this.runPhotoSwipe = function () {
      var pswpElement = document.querySelectorAll('.pswp')[0]
      if (!pswpElement) {
        return
      }
      // define options (if needed)
      var options = {
        history: false,
        focus: false,
        modal: false,
        zoomEl: true,
        shareEl: false,
        captionEl: true,
        counterEl: true,
        closeEl: false,
        escKey: false,
        clickToCloseNonZoomable: false,
        allowPanToNext: false,
        loop: true,
        tapToClose: false,
        pinchToClose: false,
        closeOnScroll: false,
        closeOnVerticalDrag: false,
        showHideOpacity: false,
        showAnimationDuration: 0,
        hideAnimationDuration: 0,
        closeElClasses: ['']
      }

      vm.representations = _.sortBy(vm.representations, [function (o) { return o.isPrimary ? 0 : 1 }])

      const items = vm.representations.map(item => {
        return {
          src: $window.URL_CA + item.url.mediumlarge,
          title: (item.title != '[VUOTO]') ? item.title : 'immagine senza titolo',
          w: item.size.width || 0,
          h: item.size.height || 0,
          toB: item.toBuy,
          toBURL: item.link,
          mimetype: item.mimetype,
          original: $window.URL_CA + item.url.page
        }
      })

      var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options)
      gallery.initialImageIndex = options.index // storing initial (clicked) image index

      gallery.listen('gettingData', function (index, item) {
        if (item.html === undefined && item.loaded === undefined) {
          item.loaded = true // unknown size

          switch (item.mimetype.split('/')[0]) {
            case 'image':
              var img = new Image()
              img.onload = function (e) {
                item.w = this.width
                item.h = this.height
                item.src = item.original
                gallery.invalidateCurrItems() // reinit Items
                gallery.updateSize(true)
              }
              img.src = item.original
              img.style.opacity = 1 // show image
              break
            case 'video':
              var url = item.original
              delete item.src
              item.html = '<div class="centered-wrapper" ><video controls><source src="' + url + '" type="video/mp4"></source><source src="' + url + '" type="video/ogg"></source>Il tuo browser non supporta la riproduzione video</video></div>'
              gallery.invalidateCurrItems()
              gallery.updateSize(true)
              break
            case 'audio':
              var url = item.original
              delete item.src
              item.html = '<div class="centered-wrapper"><audio controls><source src="' + url + '" type="audio/mpeg"></source><source src="' + url + '" type="audio/ogg"></source>Il tuo browser non supporta la riproduzione audio</audio></div>'
              gallery.invalidateCurrItems()
              gallery.updateSize(true)
              break
            default:
              break
          }
        }
      })

      gallery.listen('afterChange', function () {
        var item = items[gallery.getCurrentIndex()]

        // Hiding arrow if first and last slide
        if (gallery.getCurrentIndex() === 0) {
          jQuery('.pswp__button--arrow--left').addClass('hidden')
        } else {
          jQuery('.pswp__button--arrow--left').removeClass('hidden')
        }

        if (gallery.getCurrentIndex() === (items.length - 1)) {
          jQuery('.pswp__button--arrow--right').addClass('hidden')
        } else {
          jQuery('.pswp__button--arrow--right').removeClass('hidden')
        }

        $scope.$apply(function () {
          vm.showbuy = item.toB === true
          vm.showbuyURL = item.toBURL || ''
        })
      })

      if (!_.isEmpty(items) && !_.isEmpty(items[0].toB)) {
        vm.showbuy = true
        vm.showbuyURL = items[0].toBURL || ''
      }

      gallery.listen('preventDragEvent', function (e, isDown, preventObj) {
        preventObj.prevent = false
      })

      // angular.element('.open-fs').on('click', function () {
      //   const pswpElement = document.querySelectorAll('.pswp')[0]
      //   if (pswpElement.mozRequestFullScreen) {
      //     pswpElement.mozRequestFullScreen()
      //   } else {
      //     pswpElement.webkitRequestFullScreen()
      //   }
      // })

      // angular.element('.close-fs').on('click', function () {
      //   const pswpElement = document.querySelectorAll('.pswp')[0]
      //   if (document.mozCancelFullScreen) {
      //     document.mozCancelFullScreen()
      //   } else {
      //     document.webkitCancelFullScreen()
      //   }
      // })

      document.querySelector('#open-share').addEventListener('click', function (e) {
        e.preventDefault()
        angular.element('#share-panel').toggleClass('active')

        if (angular.element('#share-panel').hasClass('active')) {
          var index = gallery.getCurrentIndex()
          var currentSlide = items[index]
          var url = encodeURIComponent(new URL($window.location.href))

          if (_.isEmpty(currentSlide['src'])) {
            var image = currentSlide.html.match(/\((.*?)\)/)[1].replace(/('|")/g, '')
            var text = currentSlide.html.match(/<h2 [^>]+>([^<]+)<\/h2>/)[1] || vm.detail.preferred_label
          } else {
            var image = currentSlide['src']
            var text = currentSlide['titolo'] || vm.detail.preferred_label
          }
          angular.element('.pswp__share--facebook').attr('href', 'https://www.facebook.com/sharer/sharer.php?u=' + url + '&picture=' + image)
          angular.element('.pswp__share--twitter').attr('href', 'https://twitter.com/intent/tweet?text=' + text + '&amp;url=' + url)
          angular.element('.pswp__share--pinterest').attr('href', 'http://www.pinterest.com/pin/create/button/?url=' + url + '&amp;media=' + image + '&amp;description=' + text)
        }
      })

      // DA SISTEMARE
      var windowHeight = angular.element(window).innerHeight()
      $timeout(function () {
        var headerHeight = angular.element('#masthead').height()
        var titoloDet = angular.element('.titolo-det').height()
        var actionsDet = angular.element('.actions-detail').height()
        angular.element('.full-h-det').css('height', windowHeight - headerHeight - titoloDet - actionsDet)
        gallery.init()
      }, 0)
    }

    this.print = function () {
      window.print()
    }

    this.switchTree = function () {
      vm.openTree = !vm.openTree
    }

    function _loadItem (id) {
      var primary = ''
      var promise = _.isEmpty(DETAIL) ? $http.post(ENDPOINT_SUMMARY + '/data_it/' + ATTS.table + '/' + id)
        : $q.when({
          data: {
            code: 200,
            data: DETAIL
          }
        })

      promise.then(function (result) {
        if (result.data.code === 200) {
          var dati = result.data.data

          if (_.isEmpty(dati) || dati.access == 0) {
            vm.loaded = true
            vm.unavailable = true
            return
          }

          angular.copy(dati, vm.detail)

          if (!_.isEmpty(dati.genreform) && !_.isEmpty(dati.genreform.value)) {
            vm.subtitle = dati.genreform.value
          }

          if (!_.isEmpty(dati.summary[0])) {
            vm.summary = dati.summary[0]
          }

          if (!_.isEmpty(dati.representations)) {
            vm.representations = []
            vm.pdf = []
            _.each(dati.representations, (img) => {
              if (img.mimetype.startsWith('application')) {
                $http.post('https://mongoapi.lambda.promemoriagroup.com/api/sfogliatore/search', {
                  'table': 'status',
                  'limit': 1,
                  'skip': 0,
                  'fields': {},
                  'query': {
                    id: 'DIGITOURING_' + img.id,
                    finish: true
                  }
                }).then(function (response) {
                  if (response.data.count > 0) {
                    vm.pdf.push(img)
                  }
                })
              } else {
                vm.representations.push(img)
              }
            })

            vm.hasMedia = vm.representations.length > 0
            if (ATTS.table === 'ca_objects') {
              vm.runPhotoSwipe()
            }
          }
          vm.autore = _.find(dati.related, function (rel) {
            return (rel.type_rel && rel.type_rel.name == 'Autore')
          })

          if (!_.isEmpty(dati.filtri)) {
            vm.detail.supertype = _manageTag(dati.filtri, '/supertipologia')[0]
          }

          if (!_.isEmpty(vm.detail.type_id)) {
            vm.detail.type = vm.detail.type_id
            // delete(vm.detail.type_id);
          }

          if (!_.isEmpty(sessionStorage)) {
            let ultimateSearch = sessionStorage.getItem('tci_search')
            ultimateSearch = JSON.parse(ultimateSearch)
            if (!_.isEmpty(ultimateSearch) && ultimateSearch.currentPage >= 0) {
              $location.search(ultimateSearch)
              vm.searchURL = $location.url()
              vm.searchURL += '&fromdetail'
            }
          }

          vm.detail.metadati = _manageMetadata(dati.metadati)
        }
        vm.loaded = true
      })
    }

    function _manageMetadata (data) {
      var printContainer = function (elem) {
        var value = '<div>'
        elem = elem.subelement
        for (var i in elem) {
          if (elem[i] && !_.isEmpty(elem[i].label) && !_.isEmpty(elem[i].value)) {
            value += "<div class='row no-m'>\
              <div class='col-md-3 col-sm-3'><strong>" + elem[i].label + "</strong>:</div>\
              <div class='col-md-9 col-sm-9'>" + elem[i].value + '</div></div>'
          }
        }
        return value + '</div>'
      }

      var printElem = function (elem) {
        return elem.value ? "<div class='col-md-9 col-sm-9'>" + elem.value + '</div>' : printContainer(elem)
      }

      // Metadati
      var metadati = []
      for (var key in data) {
        // if (_.isEmpty(vm.summary.metadati[key])) {
        var summaryIndex = _.indexOf(vm.summary.metadati, key)
        if (summaryIndex < 0) {
          continue
        }
        var metadato = data[key]
        metadato = _.isArray(metadato) ? _.head(metadato) : metadato
        var type = !metadato.subelement ? 'string' : 'element'
        var value = _metadataException(metadato, key, data[key])
        if (value === false) {
          value = printElem(metadato)
        }

        if (key === 'descriptor') {
          metadato.label = 'Descrittori'
          metadato.value = true
        }

        if (metadato.value || metadato.subelement) {
          metadati.push({
            'label': metadato.label,
            'value': value,
            'ordine': summaryIndex || 9999,
            'type': type
          })
        }
      }

      metadati = metadati.sort(function (a, b) {
        return a.ordine - b.ordine
      })

      return metadati
    }

    function _manageTag (data, path) {
      return data.filter(function (el) {
        return el.path.split('/').length > 2 && _.startsWith(el.path, path)
      })
    }

    function init () {
      _loadItem(ID)
    }

    function _metadataException (metadata, key, values) {
      switch (key) {
        case 'external_link':
          if (!_.isEmpty(metadata.subelement.url_entry) && !_.isEmpty(metadata.subelement.url_source)) {
            return "<div class='col-md-12 no-m'><a class='link-inner' href='" + metadata.subelement.url_entry.value + "' target='_blank'>" + metadata.subelement.url_source.value + "</a><i class='p-left-half fa fa-link text-color'></i></div>"
          } else if (!_.isEmpty(metadata.subelement.url_entry)) {
            return "<div class='col-md-12 no-m'><a class='link-inner' href='" + metadata.subelement.url_entry.value + "' target='_blank'>" + metadata.subelement.url_entry.value + "</a><i class='p-left-half fa fa-link text-color'></i></div>"
          } else {
            return false
          }
        case 'topical_date':
          if (!_.isEmpty(metadata.subelement.ded_yes_no) && metadata.subelement.ded_yes_no.value == 'no') {
            return ''
          }
          return false
        case 'url_pdf':
          vm.dowPDF = metadata.value
          return ''
        case 'date':
          let tmp = "<div class='row no-m'>"
          if (!_.isEmpty(metadata.subelement.date_display) && !_.isEmpty(metadata.subelement.date_display.value)) {
            tmp += '<div class="col-md-3 col-sm-3"><strong>Data</strong></div><div class="col-md-9 col-sm-9">' + metadata.subelement.date_display.value + '</div> '
          } else if (!_.isEmpty(metadata.subelement.data_range) && !_.isEmpty(metadata.subelement.data_range.value)) {
            tmp += '<div class="col-md-3 col-sm-3"></div><div class="col-md-9 col-sm-9">' + metadata.subelement.data_range.value + '</div> '
          }
          if (!_.isEmpty(metadata.subelement.tipo_data) && !_.isEmpty(metadata.subelement.tipo_data.value)) {
            // tmp += '<br />'
            tmp += '<div class="col-md-3 col-sm-3"><strong>' + metadata.subelement.tipo_data.label + '</strong>:</div> <div class="col-md-9 col-sm-9">' + metadata.subelement.tipo_data.value + '</div>'
          }
          if (!_.isEmpty(metadata.subelement.date_notes) && !_.isEmpty(metadata.subelement.date_notes.value)) {
            // tmp += '<br />'
            tmp += '<div class="col-md-3 col-sm-3"><strong>' + metadata.subelement.date_notes.label + '</strong>:</div> <div class="col-md-9 col-sm-9">' + metadata.subelement.date_notes.value + '</div>'
          }
          return tmp + '</div>'

        case 'descriptor':
          let descrString = "<div class='row no-m'>"
          metadata = _.isArray(values) ? values : [values]

          if (!_.isEmpty(metadata) && metadata != []) {
            _.each(metadata, function (descr) {
              descrString += '<div class="col-md-9 col-sm-9">' + descr.value + '</div>'
            })
          }
          return descrString + '</div>'

        default:
          let valore = _.find(vm.detail.filtri, fil => {
            let trovato = false
            for (let k in metadata) {
              if (trovato) {
                break
              }
              trovato = ((k === 'value')
                ? metadata.value
                : metadata[k].value) === fil.name
            }
            return trovato
          })

          if (!valore) {
            return false
          }
      }
    }
  })



// WEBPACK FOOTER //
// ./src/js/pages/dettaglio.js